<template>
	<f7-page name="contents_report" class="page-bg-render">
		<f7-navbar>
			<div class="title">
				<span>문항/강의 오류신고</span>
			</div>
			<f7-nav-right>
				<f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
			</f7-nav-right>
		</f7-navbar>

		<div class="list media-list">
      <ul>
				<li class="item-content item-input item-input-outline">
          <div class="item-inner">
						신고 등록일 : {{toDate(csDateTime)}} ({{toStatus(procDateTime)}})
          </div>
        </li>
        <li class="item-content item-input item-input-outline">
          <div class="item-inner">
            <div class="item-title item-floating-label">문항/강의 코드</div>
            <div class="item-input-wrap">
              <input type="text" ref="code" placeholder="신고할 문항/강의 코드를 입력하세요." :value="code" :readonly="code != undefined">
              <span class="input-clear-button" v-if="code == undefined"></span>
            </div>
          </div>
        </li>
				<li>
					<label class="item-checkbox item-content">
						<input type="checkbox" ref="et_lecerr" name="error-type-checkbox" value="lecerr" :checked="getErrorTypeChecked('lecerr')" @change="errorTypeCheckBoxChange"/>
						<i class="icon icon-checkbox"></i>
						<div class="item-inner">
							<div class="item-title">1. 강의 오류</div>
						</div>
					</label>
				</li>
				<li>
					<label class="item-checkbox item-content">
						<input type="checkbox" ref="et_exerr" name="error-type-checkbox" value="exerr" :checked="getErrorTypeChecked('exerr')" @change="errorTypeCheckBoxChange"/>
						<i class="icon icon-checkbox"></i>
						<div class="item-inner">
							<div class="item-title">2. 문제 오류</div>
						</div>
					</label>
				</li>
				<li>
					<label class="item-checkbox item-content">
						<input type="checkbox" ref="et_anserr" name="error-type-checkbox" value="anserr" :checked="getErrorTypeChecked('anserr')" @change="errorTypeCheckBoxChange"/>
						<i class="icon icon-checkbox"></i>
						<div class="item-inner">
							<div class="item-title">3. 답안 오류</div>
						</div>
					</label>
				</li>
				<li>
					<label class="item-checkbox item-content">
						<input type="checkbox" ref="et_typerr" name="error-type-checkbox" value="typerr" :checked="getErrorTypeChecked('typerr')" @change="errorTypeCheckBoxChange"/>
						<i class="icon icon-checkbox"></i>
						<div class="item-inner">
							<div class="item-title">4. 오타 있음</div>
						</div>
					</label>
				</li>
				<li>
					<label class="item-checkbox item-content">
						<input type="checkbox" ref="et_unierr" name="error-type-checkbox" value="unierr" :checked="getErrorTypeChecked('unierr')" @change="errorTypeCheckBoxChange"/>
						<i class="icon icon-checkbox"></i>
						<div class="item-inner">
							<div class="item-title">5. 단원분류 잘못됨</div>
						</div>
					</label>
				</li>
				<li>
					<label class="item-checkbox item-content">
						<input type="checkbox" ref="et_paterr" name="error-type-checkbox" value="paterr" :checked="getErrorTypeChecked('paterr')" @change="errorTypeCheckBoxChange"/>
						<i class="icon icon-checkbox"></i>
						<div class="item-inner">
							<div class="item-title">6. 유형분류 잘못됨</div>
						</div>
					</label>
				</li>
				<li>
					<label class="item-checkbox item-content">
						<input type="checkbox" ref="et_diferr" name="error-type-checkbox" value="diferr" :checked="getErrorTypeChecked('diferr')" @change="errorTypeCheckBoxChange"/>
						<i class="icon icon-checkbox"></i>
						<div class="item-inner">
							<div class="item-title">7. 난이도 부적절</div>
						</div>
					</label>
				</li>
				<li>
					<label class="item-checkbox item-content">
						<input type="checkbox" ref="et_duerr" name="error-type-checkbox" value="duerr" :checked="getErrorTypeChecked('duerr')" @change="errorTypeCheckBoxChange"/>
						<i class="icon icon-checkbox"></i>
						<div class="item-inner">
							<div class="item-title">8. 중복 문제</div>
						</div>
					</label>
				</li>
				<li>
					<label class="item-checkbox item-content">
						<input type="checkbox" ref="et_corerr" name="error-type-checkbox" value="corerr" :checked="getErrorTypeChecked('corerr')" @change="errorTypeCheckBoxChange"/>
						<i class="icon icon-checkbox"></i>
						<div class="item-inner">
							<div class="item-title">9. 교과과정 분류 잘못됨</div>
						</div>
					</label>
				</li>
				<li>
					<label class="item-checkbox item-content">
						<input type="checkbox" ref="et_etcerr" name="error-type-checkbox" value="etcerr" :checked="getErrorTypeChecked('etcerr')" @change="errorTypeCheckBoxChange"/>
						<i class="icon icon-checkbox"></i>
						<div class="item-inner">
							<div class="item-title">10. 그외 기타</div>
						</div>
					</label>
				</li>
				<li>
					<div class="block-title">
						문항/강의 오류신고 내용
					</div>
				</li>
				<li class="padding">
					<textarea ref="content" :readonly="csKey != undefined" style="height:160px; border:solid 1px #ddd;" placeholder="오류 내용을 입력하세요. (생략 가능)" v-html="toContent(content)"></textarea>
				</li>
      </ul>
		</div>

		<div class="list media-list">
      <ul>
				<template v-for="(item,i) in commentList">
				<li :key="'i'+i">
					<div class="item-inner item-content">
						<div class="item-title-row">
							<div class="item-title" style="color:#aaa;">
								<span v-if="item.COMMENT_USER_KEY == writeUserKey">작성자: 관리자</span>
								<span v-else>작성자: 나</span>
							</div>
							<div class="item-after">{{toDate(item.COMMENT_DATETIME)}}</div>
						</div>
						<div v-html="toComment(item.COMMENT_CONTENT)"></div>
					</div>
				</li>
				</template>
				<li v-if="csKey != undefined">
					<div class="item-inner item-content">
						<div class="item-title-row">
							<div class="item-title">
								댓글 입력
							</div>
						</div>

						<div class="padding">
							<textarea ref="comment" style="height:160px; border:solid 1px #ddd;" placeholder="댓글을 입력하세요."></textarea>
						</div>
						
					</div>
				</li>
      </ul>
    </div>

		<div class="padding">
			<div class="row">
				<div class="left"></div>
				<div class="right">
					<button class="button button-fill" v-on:click="saveReportButtonClick" v-if="csKey == undefined">신고 등록</button>
					<button class="button button-fill" v-on:click="saveCommentButtonClick" v-else>댓글 저장</button>
				</div>
			</div>
		</div>
		
	</f7-page>
</template>

<script>
	import Vue from 'vue';
	import { f7 } from 'framework7-vue';

	import store from '../../../js/store';

	import MODULE from '../../../js/common/module';
	import AUTH from '../../../js/common/auth.js';
	import PAGES from '../../../js/pages';
	import API from '../../../js/common/api.js';
	import CONST from '../../../js/common/constant';
	
	export default {
		data() {
			return {
				csKey: undefined,
				writeUserKey: undefined,
				csDateTime: undefined,
				csStatus: undefined,
				code: "",
				errorTypes: "",
				content: "",
				procDateTime: undefined,
				commentList: []
			}
		},
		mounted() {
			var _this = this;

			// 반드시 템플릿이 바인딩 되기전에 템플릿에서 사용하는 변수를 세팅해야 한다.
			// 특히, textEditor에서 csKey를 참조하는 경우 !!
			_this.csKey = _this.$f7route.context.csKey;
			_this.code = _this.$f7route.context.code;

			setTimeout(function() {
				if (_this.csKey != undefined) {
					_this.loadContentsReport();
				} else {
					_this.readyContentsReport();
				}
			}, 300);
		},
		methods: {
			loadContentsReport() {
				var _this = this;

				let param = {
					pCSKey : _this.csKey
				};


				API.ajaxRequest({
					url: API.getContentsReportUrl(),
					data: param
				}).then(function (data) {
					
					_this.writeUserKey = data.CS_WRITE_USER_KEY;
					_this.csDateTime = data.CS_DATETIME;
					_this.csStatus = data.CS_STATUS;
					_this.code = data.CS_CODE;
					_this.errorTypes = data.CS_OPTIONS;
					_this.content = data.CS_CONTENT;
					_this.procDateTime = data.PROC_DATETIME;
					_this.commentList = data.commentList;

					var commentElement = $(_this.$refs.comment);
					commentElement.val("");

				}).catch(function (code) {
					if (code == CONST.resultCode.EMPTY) {
						PAGES.back();
						MODULE.DialogBox.message("에러", "존재하지 않는 코드입니다. 코드를 확인하세요.");
						return;
					}
					
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});
			},
			readyContentsReport() {
				var _this = this;

				_this.csKey = undefined;
				_this.writeUserKey = undefined;
				_this.csDateTime = undefined;
				_this.csStatus = undefined;
				// _this.code = 변경하지 않음. (code가 넘어오는 경우 있음.)
				_this.errorTypes = "";
				_this.content = "";
				_this.commentList = [];

				var commentElement = $(_this.$refs.comment);
				commentElement.val("");
			},
			saveReportButtonClick() {
				var _this = this;

				var code = _this.$refs.code.value;
				if (MODULE.Util.isEmpty(code)) {
					MODULE.DialogBox.warnToast("신고할 문항/강의 코드를 입력하세요.");
					return false;
				}

				var errorTypes = "";
				
				if (_this.$refs.et_lecerr.checked) {
					if (errorTypes != "") errorTypes += ".";
					errorTypes += _this.$refs.et_lecerr.value;
				} 

				if (_this.$refs.et_exerr.checked) {
					if (errorTypes != "") errorTypes += ".";
					errorTypes += _this.$refs.et_exerr.value;
				}

				if (_this.$refs.et_anserr.checked) {
					if (errorTypes != "") errorTypes += ".";
					errorTypes += _this.$refs.et_anserr.value;
				}

				if (_this.$refs.et_typerr.checked) {
					if (errorTypes != "") errorTypes += ".";
					errorTypes += _this.$refs.et_typerr.value;
				}

				if (_this.$refs.et_unierr.checked) {
					if (errorTypes != "") errorTypes += ".";
					errorTypes += _this.$refs.et_unierr.value;
				}

				if (_this.$refs.et_paterr.checked) {
					if (errorTypes != "") errorTypes += ".";
					errorTypes += _this.$refs.et_paterr.value;
				}

				if (_this.$refs.et_diferr.checked) {
					if (errorTypes != "") errorTypes += ".";
					errorTypes += _this.$refs.et_diferr.value;
				}

				if (_this.$refs.et_duerr.checked) {
					if (errorTypes != "") errorTypes += ".";
					errorTypes += _this.$refs.et_duerr.value;
				}

				if (_this.$refs.et_corerr.checked) {
					if (errorTypes != "") errorTypes += ".";
					errorTypes += _this.$refs.et_corerr.value;
				}

				if (_this.$refs.et_etcerr.checked) {
					if (errorTypes != "") errorTypes += ".";
					errorTypes += _this.$refs.et_etcerr.value;
				}
				
				if (MODULE.Util.isEmpty(errorTypes)) {
					MODULE.DialogBox.warnToast("오류 종류를 선택 하세요.");
					return false;
				}

				var contentElement = $(_this.$refs.content);
				var content = contentElement.val();
				if (MODULE.Util.isEmpty(content)) {
					content = "-";
				}

				let param = {
					pContentsCode: code,
					pErrorType: errorTypes,
					pContent: content
				};


				API.jsonRequest({
					url: API.addContentsReportUrl(),
					data: param
				}).then(function (data) {

					MODULE.DialogBox.infoToast("오류신고가 등록되었습니다.");

					PAGES.setReturnObj({
						code: "NEED_REFRESH"
					});
					PAGES.back();

				}).catch(function (code) {
					if (code == CONST.resultCode.EMPTY) {
						PAGES.back();
						MODULE.DialogBox.message("에러", "존재하지 않는 코드입니다. 코드를 확인하세요.");
						return;
					}
					
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});
			},
			saveCommentButtonClick() {
				var _this = this;

				var commentElement = $(_this.$refs.comment);
				var comment = commentElement.val();
				if (MODULE.Util.isEmpty(comment)) {
					MODULE.DialogBox.warnToast("댓글을 입력 하세요.");
					return;
				}

				let param = {
					pCSKey: _this.csKey,
					pComment: comment
				};


				API.jsonRequest({
					url: API.addReportCommentUrl(),
					data: param
				}).then(function (data) {
					_this.loadContentsReport();
				}).catch(function (code) {
					if (code == CONST.resultCode.EMPTY) {
						PAGES.back();
						MODULE.DialogBox.message("에러", "존재하지 않는 코드입니다. 코드를 확인하세요.");
						return;
					}
					
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});
			},
			getErrorTypeChecked(value) {
				var _this = this;

				var isIn = MODULE.Util.isInGroupValue(value, _this.errorTypes);

				if (isIn) {
					return true;
				} else {
					return false;
				}
			},
			errorTypeCheckBoxChange(e) {
				var _this = this;
				var element = e.target;

				if (_this.csKey == undefined) {
					return true;
				} else {
					element.checked = !element.checked;		// prevent change
				}
			},
			toDate(datetime) {
				var _this = this;

				if (_this.csKey == undefined) {
					return moment().format("YYYY-MM-DD HH:mm");
				} else {
					return moment(datetime).format("YYYY-MM-DD HH:mm");
				}
			},
			toContent(content) {
				var _this = this;

				if (_this.csKey == undefined) {
					return "";
				} else {
					return (MODULE.Util.isEmpty(content) ? "오류 설명 없음." : content);
				}
			},
			toComment(comment) {
				var _this = this;

				var c = comment;
				c = c.replace(/\r\n/gi, "<br/>");
				c = c.replace(/\n/gi, "<br/>");

				return c;
			},
			toStatus() {
				var _this = this;

				if (_this.csKey == undefined) {
					return "처리상태 : 작성중";
				} else if (_this.csStatus == "writed") {
					return "처리상태 : 접수대기중";
				} else if (_this.csStatus == "inprogress") {
					return "처리상태 : 담당자 처리중";
				} else if (_this.csStatus == "hold") {
					return "처리상태 : 처리 보류중";
				} else if (_this.csStatus == "sendback") {
					return "처리상태 : 반송됨";
				} else if (_this.csStatus == "complete") {
					return "처리상태 : 처리완료";
				}
			}
		}
	}

</script>